import { useNavigate } from 'react-router-dom';
import PageLoader from '@/components/PageLoader';
import { useReveal } from '@/hooks/useReveal';
import { NAV } from '@/data/mockData';
import { GUIDE_ICON } from '@/components/GuideIcons';
import s from './Sitemap.module.scss';

// ============================================================================
//  사이트맵 (/sitemap)
//  [2026-10-11 사용자] 헤더 유틸 '사이트맵'이 죽은 링크(href=#)였음 → 신규 페이지로 연결.
//    요구: evs.com/as 디자인 철학 / 히어로 이미지 없음 / white 바탕 / 심플·세련 라인 아이콘(GUIDE_ICON).
//    데이터는 실제 NAV(mockData)를 그대로 사용 → 메뉴/서브메뉴와 '자동 동기화'(별도 유지보수 불필요).
//    메인메뉴별 대표 아이콘만 매핑(의미 기반). 아이콘 없는 하위는 텍스트 링크.
// ============================================================================

// 메인메뉴 → 대표 라인아이콘(GUIDE_ICON 키, 실재 확인). 의미 기반 매핑.
const MENU_ICON: Record<string, string> = {
  '제품': 'gateway',
  '안전': 'certified',
  '환경': 'air',
  '설치안내': 'action',
  '설치 사례': 'doc',
  '고객지원': 'phone',
  '회사소개': 'building',
};

const Reveal = ({ className = '', children }: { className?: string; children: React.ReactNode }) => {
  const ref = useReveal<HTMLDivElement>();
  return <div className={`${className} anim-scroll`} ref={ref}>{children}</div>;
};

export default function Sitemap() {
  const navigate = useNavigate();
  const go = (to?: string) => (e: React.MouseEvent) => { e.preventDefault(); if (to) navigate(to); };

  return (
    <main className={s.page}>
      <PageLoader />

      {/* 히어로 이미지 없음 — 심플 텍스트 헤더(white) */}
      <header className={s.head}>
        <p className={s.eyebrow}>SITEMAP</p>
        <h1 className={s.title}>사이트맵</h1>
        <p className={s.sub}>EVS 웹사이트의 전체 메뉴를 한눈에 안내합니다. 원하시는 메뉴로 바로 이동하세요.</p>
      </header>

      <section className={s.body}>
        <div className={s.grid}>
          {NAV.map((group) => (
            <Reveal key={group.label} className={s.group}>
              <a className={s.groupHead} href={group.to || '#'} onClick={go(group.to)}>
                <span className={s.icon} aria-hidden>{GUIDE_ICON[MENU_ICON[group.label] || 'solution']}</span>
                <h2 className={s.groupTitle}>{group.label}</h2>
              </a>
              {group.children && group.children.length > 0 && (
                <ul className={s.links}>
                  {group.children.map((c) => (
                    <li key={c.label}>
                      <a href={c.to || '#'} onClick={go(c.to)} className={s.link}>
                        {c.dot && <i className={`${s.dot} ${c.dot === 'safety' ? s.dotSafety : s.dotEnv}`} />}
                        {c.label}
                      </a>
                    </li>
                  ))}
                </ul>
              )}
            </Reveal>
          ))}
        </div>
      </section>
    </main>
  );
}
